module.exports = __webpack_public_path__ + "img/BE0563635128.64331277.png";